import { CardContent, Tooltip, tooltipClasses } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import { spc } from '~c/components/base/spacer';
import Text from '~c/components/base/text';

interface GenericCardContentProps {
  className?: string;
  children?: React.ReactNode;
}

const GenericCardContentImpl: React.FC<GenericCardContentProps> = ({
  className,
  children,
}) => {
  return (
    <CardContent className={`${className} content-wrapper`}>
      {children}
    </CardContent>
  );
};

export const GenericCardContent = muiStyled(GenericCardContentImpl)(
  ({ theme }) => css`
    padding: ${theme.spacing(4)} ${theme.spacing(4)} 0;
    flex-grow: 1;
    overflow: hidden;

    & .${tooltipClasses.tooltip} {
      max-width: 350px;
      background-color: black;
      font-size: 15px;
    }

    & .${tooltipClasses.arrow} {
      color: black;
    }
  `
);
